import { LocationManager } from './LocationManager'

declare global {
  // eslint-disable-next-line no-var
  var _locationManager: LocationManager | undefined
}

export const getLocationManager = (): LocationManager => {
  if (!globalThis._locationManager) {
    globalThis._locationManager = LocationManager.getInstance()

    if (typeof window !== 'undefined') {
      globalThis._locationManager
        .init()
        .catch((error) =>
          console.error('Error initializing LocationManager:', error),
        )
    } else {
      const intervalId = setInterval(() => {
        if (typeof window !== 'undefined') {
          globalThis._locationManager
            ?.init()
            .catch((error) =>
              console.error('Error initializing LocationManager:', error),
            )
          clearInterval(intervalId)
        }
      }, 100)
    }
  }

  return globalThis._locationManager
}
